/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Deposits JSON Schemas 

const _ARCHIVED_DEPOSIT_CLOSE_REQUEST_JSON_SCHEMA = {
    "$ref": "#/definitions/ArchivedDepositCloseRequestSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "ArchivedDepositCloseRequestSchema": {
            "additionalProperties": false,
            "properties": {
                "amount_in_cents_to_landlord": {
                    "cents_value": true,
                    "format": "integer",
                    "title": "Amount In Cents To Landlord",
                    "type": "number"
                },
                "amount_in_cents_to_tenant": {
                    "cents_value": true,
                    "format": "integer",
                    "title": "Amount In Cents To Tenant",
                    "type": "number"
                },
                "archive_uid": {
                    "reference_type": "uuid",
                    "title": "Archive Uid",
                    "type": "string",
                    "uid_resource_type": "archived_deposit_close_request"
                },
                "attached_files_uid": {
                    "reference_type": "uuid",
                    "title": "Attached Files Uid",
                    "type": "string",
                    "uid_resource_type": "attached_storage_files"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "deposit_uid": {
                    "reference_type": "uuid",
                    "title": "Deposit Uid",
                    "type": "string",
                    "uid_resource_type": "deposit"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes": {
                    "title": "Notes",
                    "type": "string"
                },
                "reason_for_close": {
                    "maxLength": 1024,
                    "title": "Reason For Close",
                    "type": "string"
                },
                "response_reason": {
                    "maxLength": 1024,
                    "title": "Response Reason",
                    "type": "string"
                },
                "state": {
                    "class_name": "CloseRequestState",
                    "enum": [
                        "pending",
                        "accepted",
                        "landlord_closed",
                        "rejected",
                        "cancelled"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "triggering_account_type": {
                    "class_name": "DepositAccountType",
                    "enum": [
                        "landlord",
                        "tenant",
                        "mediator"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "triggering_account_uid": {
                    "reference_type": "uuid",
                    "title": "Triggering Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                }
            },
            "required": [
                "amount_in_cents_to_landlord",
                "amount_in_cents_to_tenant",
                "archive_uid",
                "attached_files_uid",
                "created_timestamp",
                "deposify_tags",
                "deposit_uid",
                "last_updated_timestamp",
                "notes",
                "reason_for_close",
                "response_reason",
                "state",
                "triggering_account_type",
                "triggering_account_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _COMPLIANCE_JSON_SCHEMA = {
    "$ref": "#/definitions/ComplianceSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "ComplianceSchema": {
            "additionalProperties": false,
            "properties": {
                "action_payload": {
                    "additionalProperties": {},
                    "title": "Action Payload",
                    "type": "object"
                },
                "action_type": {
                    "class_name": "ComplianceActionType",
                    "enum": [
                        "generate_deposit_receipt",
                        "daily_interest",
                        "quarterly_interest_payout_and_report"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "compliance_uid": {
                    "reference_type": "uuid",
                    "title": "Compliance Uid",
                    "type": "string",
                    "uid_resource_type": "compliance"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "description": {
                    "title": "Description",
                    "type": "string"
                },
                "disabled": {
                    "title": "Disabled",
                    "type": "boolean"
                },
                "handled_by_dedicated_function": {
                    "title": "Handled By Dedicated Function",
                    "type": "boolean"
                },
                "id": {
                    "format": "integer",
                    "title": "Id",
                    "type": "number"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "name": {
                    "title": "Name",
                    "type": "string"
                },
                "rule_ids": {
                    "items": {
                        "format": "integer",
                        "title": "rule_ids",
                        "type": "number"
                    },
                    "title": "Rule Ids",
                    "type": "array"
                },
                "type": {
                    "class_name": "ComplianceType",
                    "enum": [
                        "hourly",
                        "daily",
                        "quarter_year"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                }
            },
            "required": [
                "action_payload",
                "action_type",
                "compliance_uid",
                "created_timestamp",
                "description",
                "disabled",
                "handled_by_dedicated_function",
                "id",
                "last_updated_timestamp",
                "name",
                "rule_ids",
                "type"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _COMPLIANCE_HISTORY_JSON_SCHEMA = {
    "$ref": "#/definitions/ComplianceHistorySchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "ComplianceHistorySchema": {
            "additionalProperties": false,
            "properties": {
                "compliance_history_uid": {
                    "reference_type": "uuid",
                    "title": "Compliance History Uid",
                    "type": "string",
                    "uid_resource_type": "compliance_history"
                },
                "compliance_id": {
                    "format": "integer",
                    "title": "Compliance Id",
                    "type": "number"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposit_uid": {
                    "reference_type": "uuid",
                    "title": "Deposit Uid",
                    "type": "string",
                    "uid_resource_type": "deposit"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                }
            },
            "required": [
                "compliance_history_uid",
                "compliance_id",
                "created_timestamp",
                "deposit_uid",
                "last_updated_timestamp"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _COMPLIANCE_RULE_JSON_SCHEMA = {
    "$ref": "#/definitions/ComplianceRuleSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "ComplianceRuleSchema": {
            "additionalProperties": false,
            "properties": {
                "compliance_rule_uid": {
                    "reference_type": "uuid",
                    "title": "Compliance Rule Uid",
                    "type": "string",
                    "uid_resource_type": "compliance_rule"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "id": {
                    "format": "integer",
                    "title": "Id",
                    "type": "number"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "type": {
                    "class_name": "ComplianceRuleType",
                    "enum": [
                        "days_remaining",
                        "deposit_amount",
                        "deposit_geo_state",
                        "deposit_state",
                        "payment_cleared",
                        "receipt_file_uid",
                        "interest_enabled",
                        "funds_location_type"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "value": {
                    "title": "Value",
                    "type": "string"
                },
                "value_operator": {
                    "class_name": "ComplianceValueOperator",
                    "enum": [
                        "operator_not_used",
                        "less_than",
                        "less_than_or_equal",
                        "equal",
                        "not_equal",
                        "greater_than_or_equal",
                        "greater_than"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                }
            },
            "required": [
                "compliance_rule_uid",
                "created_timestamp",
                "id",
                "last_updated_timestamp",
                "type",
                "value",
                "value_operator"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _DEPOSIT_JSON_SCHEMA = {
    "$ref": "#/definitions/DepositSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "DepositSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "active_close_request_uid": {
                    "reference_type": "uuid",
                    "title": "Active Close Request Uid",
                    "type": "string",
                    "uid_resource_type": "deposit_close_request"
                },
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount",
                    "type": "number",
                    "ui:placeholder": "$0",
                    "ui:widget": "DollarInputField"
                },
                "attached_files_uid": {
                    "reference_type": "uuid",
                    "title": "Attached Files Uid",
                    "type": "string",
                    "uid_resource_type": "attached_storage_files"
                },
                "became_active_timestamp": {
                    "format": "date-time",
                    "title": "Became Active Timestamp",
                    "type": "string"
                },
                "cancelled_timestamp": {
                    "format": "date-time",
                    "title": "Cancelled Timestamp",
                    "type": "string"
                },
                "closed_timestamp": {
                    "format": "date-time",
                    "title": "Closed Timestamp",
                    "type": "string"
                },
                "completed_compliances": {
                    "items": {
                        "format": "integer",
                        "title": "completed_compliances",
                        "type": "number"
                    },
                    "title": "Completed Compliances",
                    "type": "array"
                },
                "cover_photo_uid": {
                    "reference_type": "uuid",
                    "title": "Cover Photo Uid",
                    "type": "string",
                    "uid_resource_type": "storage_file"
                },
                "created_by_account_uid": {
                    "reference_type": "uuid",
                    "title": "Created By Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "cumulative_interest_in_cents_decimal": {
                    "format": "decimal",
                    "maximum": 999999999999999.99999999999999999,
                    "minimum": 0.0,
                    "title": "Cumulative Interest In Cents Decimal",
                    "type": "number"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "deposit_group_uid": {
                    "reference_type": "uuid",
                    "title": "Deposit Group Uid",
                    "type": "string",
                    "uid_resource_type": "deposit_group"
                },
                "deposit_type": {
                    "class_name": "DepositType",
                    "enum": [
                        "security",
                        "pet",
                        "utility",
                        "last_months_rent"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "deposit_uid": {
                    "reference_type": "uuid",
                    "title": "Deposit Uid",
                    "type": "string",
                    "uid_resource_type": "deposit"
                },
                "disabled_compliances": {
                    "items": {
                        "format": "integer",
                        "title": "disabled_compliances",
                        "type": "number"
                    },
                    "title": "Disabled Compliances",
                    "type": "array"
                },
                "dispute_uid": {
                    "reference_type": "uuid",
                    "title": "Dispute Uid",
                    "type": "string",
                    "uid_resource_type": "dispute"
                },
                "disputed_timestamp": {
                    "format": "date-time",
                    "title": "Disputed Timestamp",
                    "type": "string"
                },
                "end_amount_in_cents_to_landlord": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "End Amount In Cents To Landlord",
                    "type": "number"
                },
                "end_amount_in_cents_to_tenant": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "End Amount In Cents To Tenant",
                    "type": "number"
                },
                "end_date": {
                    "format": "date-time",
                    "title": "End Date",
                    "type": "string"
                },
                "funds_location": {
                    "class_name": "FundsLocationType",
                    "enum": [
                        "bank_account",
                        "payment_stripe",
                        "payment_yapstone",
                        "payment_priority_ach",
                        "deposify_loan",
                        "user_deposited_funds_sezzle"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "funds_location_uid": {
                    "reference_type": "uuid",
                    "title": "Funds Location Uid",
                    "type": "string"
                },
                "geo_state": {
                    "enum": [
                        "AL",
                        "AK",
                        "AZ",
                        "AR",
                        "CA",
                        "CO",
                        "CT",
                        "DE",
                        "FL",
                        "GA",
                        "HI",
                        "ID",
                        "IL",
                        "IN",
                        "KS",
                        "KY",
                        "LA",
                        "ME",
                        "MD",
                        "MA",
                        "MN",
                        "MS",
                        "MO",
                        "MT",
                        "NV",
                        "NH",
                        "NJ",
                        "NY",
                        "NC",
                        "OR",
                        "PA",
                        "RI",
                        "SC",
                        "SD",
                        "TN",
                        "TX",
                        "UT",
                        "VT",
                        "VA",
                        "WA",
                        "WV",
                        "WI",
                        "WY"
                    ],
                    "enumNames": [],
                    "maxLength": 2,
                    "messages": {
                        "type": "U.S. State is required"
                    },
                    "minLength": 2,
                    "title": "U.S. State",
                    "type": "string",
                    "ui:widget": "USStateAutoSuggestionRecentlyUsedField"
                },
                "has_notes": {
                    "title": "Has Notes",
                    "type": "boolean"
                },
                "interest_enabled": {
                    "title": "Interest Enabled",
                    "type": "boolean"
                },
                "interest_enabled_timestamp": {
                    "format": "date-time",
                    "title": "Interest Enabled Timestamp",
                    "type": "string"
                },
                "interest_paid_into_user_account_balance_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Interest Paid Into User Account Balance In Cents",
                    "type": "number"
                },
                "interest_principal_in_cents_decimal": {
                    "format": "decimal",
                    "maximum": 999999999999999.99999999999999999,
                    "minimum": 0.0,
                    "title": "Interest Principal In Cents Decimal",
                    "type": "number"
                },
                "interest_to_date_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Interest To Date In Cents",
                    "type": "number"
                },
                "invoice_count": {
                    "format": "integer",
                    "title": "Invoice Count",
                    "type": "number"
                },
                "landlord_accepted_timestamp": {
                    "format": "date-time",
                    "title": "Landlord Accepted Timestamp",
                    "type": "string"
                },
                "landlord_account_uid": {
                    "reference_type": "uuid",
                    "title": "Landlord Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "landlord_archived": {
                    "title": "Landlord Archived",
                    "type": "boolean"
                },
                "landlord_has_accepted": {
                    "title": "Landlord Has Accepted",
                    "type": "boolean"
                },
                "landlord_transferred_timestamp": {
                    "format": "date-time",
                    "title": "Landlord Transferred Timestamp",
                    "type": "string"
                },
                "last_interest_applied_timestamp": {
                    "format": "date-time",
                    "title": "Last Interest Applied Timestamp",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "mailbox_uid": {
                    "reference_type": "uuid",
                    "title": "Mailbox Uid",
                    "type": "string",
                    "uid_resource_type": "mailbox"
                },
                "meta_data": {
                    "additionalProperties": {},
                    "title": "Meta Data",
                    "type": "object"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "outstanding_landlord_prompts": {
                    "items": {
                        "format": "integer",
                        "title": "outstanding_landlord_prompts",
                        "type": "number"
                    },
                    "title": "Outstanding Landlord Prompts",
                    "type": "array"
                },
                "outstanding_tenant_prompts": {
                    "items": {
                        "format": "integer",
                        "title": "outstanding_tenant_prompts",
                        "type": "number"
                    },
                    "title": "Outstanding Tenant Prompts",
                    "type": "array"
                },
                "payment_cleared": {
                    "title": "Payment Cleared",
                    "type": "boolean"
                },
                "payment_cleared_timestamp": {
                    "format": "date-time",
                    "title": "Payment Cleared Timestamp",
                    "type": "string"
                },
                "property_uid": {
                    "reference_type": "uuid",
                    "title": "Property Uid",
                    "type": "string",
                    "uid_resource_type": "property"
                },
                "receipt_file_uid": {
                    "reference_type": "uuid",
                    "title": "Receipt File Uid",
                    "type": "string",
                    "uid_resource_type": "storage_file"
                },
                "start_date": {
                    "format": "date-time",
                    "title": "Start Date",
                    "type": "string"
                },
                "state": {
                    "class_name": "DepositState",
                    "enum": [
                        "pending",
                        "active",
                        "close_requested",
                        "closed",
                        "disputed",
                        "dispute_split_proposed",
                        "mediator_involved_dispute",
                        "mediator_split_proposed",
                        "cancelled"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "tenant_accepted_timestamp": {
                    "format": "date-time",
                    "title": "Tenant Accepted Timestamp",
                    "type": "string"
                },
                "tenant_account_uid": {
                    "reference_type": "uuid",
                    "title": "Tenant Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "tenant_archived": {
                    "title": "Tenant Archived",
                    "type": "boolean"
                },
                "tenant_funds_lock_uid": {
                    "reference_type": "uuid",
                    "title": "Tenant Funds Lock Uid",
                    "type": "string",
                    "uid_resource_type": "funds_lock"
                },
                "tenant_has_accepted": {
                    "title": "Tenant Has Accepted",
                    "type": "boolean"
                },
                "tenant_invoice_uid": {
                    "reference_type": "uuid",
                    "title": "Tenant Invoice Uid",
                    "type": "string",
                    "uid_resource_type": "invoice"
                },
                "tenant_transferred_timestamp": {
                    "format": "date-time",
                    "title": "Tenant Transferred Timestamp",
                    "type": "string"
                },
                "title": {
                    "maxLength": 128,
                    "minLength": 3,
                    "title": "Title",
                    "type": "string"
                },
                "transferred_to_landlord_account_uid": {
                    "reference_type": "uuid",
                    "title": "Transferred To Landlord Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "transferred_to_tenant_account_uid": {
                    "reference_type": "uuid",
                    "title": "Transferred To Tenant Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "voyager_property_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Property Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property"
                },
                "voyager_property_unit_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Property Unit Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property_unit"
                },
                "voyager_resident_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Resident Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_resident"
                },
                "withheld_funds_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Withheld Funds In Cents",
                    "type": "number"
                },
                "rhino_property_id":{
                    "title": "Rhino Property ID",
                    "type": "number"
                },
                "rhino_unit_id":{
                    "title": "Rhino Unit ID",
                    "type": "number"
                },
                "rhino_property_owner_id":{
                    "title": "Rhino Property Owner ID",
                    "type": "number"
                },
                "rhino_policy_application_id":{
                    "title": "Rhino Policy Application Id",
                    "type": "number"
                },
                "funds_held_by_partner": {
                    "title": "Funds Held By Partner",
                    "type": "boolean"
                },
            },
            "required": [
                "active_close_request_uid",
                "amount_in_cents",
                "attached_files_uid",
                "became_active_timestamp",
                "cancelled_timestamp",
                "closed_timestamp",
                "completed_compliances",
                "cover_photo_uid",
                "created_by_account_uid",
                "created_timestamp",
                "cumulative_interest_in_cents_decimal",
                "deposify_tags",
                "deposit_group_uid",
                "deposit_type",
                "deposit_uid",
                "disabled_compliances",
                "dispute_uid",
                "disputed_timestamp",
                "end_amount_in_cents_to_landlord",
                "end_amount_in_cents_to_tenant",
                "end_date",
                "funds_location",
                "funds_location_uid",
                "geo_state",
                "has_notes",
                "interest_enabled",
                "interest_enabled_timestamp",
                "interest_paid_into_user_account_balance_in_cents",
                "interest_principal_in_cents_decimal",
                "interest_to_date_in_cents",
                "invoice_count",
                "landlord_accepted_timestamp",
                "landlord_account_uid",
                "landlord_archived",
                "landlord_has_accepted",
                "landlord_transferred_timestamp",
                "last_interest_applied_timestamp",
                "last_updated_timestamp",
                "mailbox_uid",
                "meta_data",
                "outstanding_landlord_prompts",
                "outstanding_tenant_prompts",
                "payment_cleared",
                "payment_cleared_timestamp",
                "property_uid",
                "receipt_file_uid",
                "start_date",
                "state",
                "tenant_accepted_timestamp",
                "tenant_account_uid",
                "tenant_archived",
                "tenant_funds_lock_uid",
                "tenant_has_accepted",
                "tenant_invoice_uid",
                "tenant_transferred_timestamp",
                "title",
                "transferred_to_landlord_account_uid",
                "transferred_to_tenant_account_uid",
                "voyager_property_uid",
                "voyager_property_unit_uid",
                "voyager_resident_uid",
                "withheld_funds_in_cents"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _DEPOSIT_ADJUSTMENT_JSON_SCHEMA = {
    "$ref": "#/definitions/DepositAdjustmentSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "DepositAdjustmentSchema": {
            "additionalProperties": false,
            "properties": {
                "adjustment_type": {
                    "class_name": "DepositAdjustmentType",
                    "enum": [
                        "debit",
                        "credit"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "adjustment_uid": {
                    "reference_type": "uuid",
                    "title": "Adjustment Uid",
                    "type": "string",
                    "uid_resource_type": "deposit_adjustment"
                },
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount",
                    "type": "number",
                    "ui:placeholder": "$0",
                    "ui:widget": "DollarInputField"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposit_uid": {
                    "reference_type": "uuid",
                    "title": "Deposit Uid",
                    "type": "string",
                    "uid_resource_type": "deposit"
                },
                "invoice_item_uid": {
                    "reference_type": "uuid",
                    "title": "Invoice Item Uid",
                    "type": "string",
                    "uid_resource_type": "invoice_item"
                },
                "invoice_uid": {
                    "reference_type": "uuid",
                    "title": "Invoice Uid",
                    "type": "string",
                    "uid_resource_type": "invoice"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "private_notes": {
                    "title": "Private Notes",
                    "type": "string"
                },
                "public_reason_for_adjustment": {
                    "title": "Public Reason For Adjustment",
                    "type": "string"
                }
            },
            "required": [
                "adjustment_type",
                "adjustment_uid",
                "amount_in_cents",
                "created_timestamp",
                "deposit_uid",
                "invoice_item_uid",
                "invoice_uid",
                "last_updated_timestamp",
                "private_notes",
                "public_reason_for_adjustment"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _DEPOSIT_BANK_MAPPING_JSON_SCHEMA = {
    "$ref": "#/definitions/DepositBankMappingSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "DepositBankMappingSchema": {
            "additionalProperties": false,
            "properties": {
                "bank_account_uid": {
                    "reference_type": "uuid",
                    "title": "Bank Account Uid",
                    "type": "string",
                    "uid_resource_type": "bank_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "geo_state": {
                    "maxLength": 2,
                    "minLength": 2,
                    "reference_type": "us_state",
                    "title": "Geo State",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "map_uid": {
                    "reference_type": "uuid",
                    "title": "Map Uid",
                    "type": "string",
                    "uid_resource_type": "deposit_bank_mapping"
                }
            },
            "required": [
                "bank_account_uid",
                "created_timestamp",
                "geo_state",
                "last_updated_timestamp",
                "map_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _DEPOSIT_BULK_IMPORT_JSON_SCHEMA = {
    "$ref": "#/definitions/DepositBulkImportSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "DepositBulkImportSchema": {
            "additionalProperties": false,
            "properties": {
                "attached_files_uid": {
                    "reference_type": "uuid",
                    "title": "Attached Files Uid",
                    "type": "string",
                    "uid_resource_type": "attached_storage_files"
                },
                "bulk_import_uid": {
                    "reference_type": "uuid",
                    "title": "Bulk Import Uid",
                    "type": "string",
                    "uid_resource_type": "deposits_bulk_import"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "deposit_uids": {
                    "items": {
                        "title": "deposit_uids",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Deposit Uids",
                    "type": "array",
                    "uid_resource_type": "deposit"
                },
                "description": {
                    "title": "Description",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "organization_uid": {
                    "reference_type": "uuid",
                    "title": "Organization Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "title": {
                    "title": "Title",
                    "type": "string"
                }
            },
            "required": [
                "attached_files_uid",
                "bulk_import_uid",
                "deposit_uids",
                "description",
                "organization_uid",
                "title"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _DEPOSIT_CLOSE_REQUEST_JSON_SCHEMA = {
    "$ref": "#/definitions/DepositCloseRequestSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "DepositCloseRequestSchema": {
            "additionalProperties": false,
            "properties": {
                "amount_in_cents_to_landlord": {
                    "cents_value": true,
                    "format": "integer",
                    "title": "Amount In Cents To Landlord",
                    "type": "number"
                },
                "amount_in_cents_to_tenant": {
                    "cents_value": true,
                    "format": "integer",
                    "title": "Amount In Cents To Tenant",
                    "type": "number"
                },
                "attached_files_uid": {
                    "reference_type": "uuid",
                    "title": "Attached Files Uid",
                    "type": "string",
                    "uid_resource_type": "attached_storage_files"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "deposit_uid": {
                    "reference_type": "uuid",
                    "title": "Deposit Uid",
                    "type": "string",
                    "uid_resource_type": "deposit"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes": {
                    "title": "Notes",
                    "type": "string"
                },
                "reason_for_close": {
                    "maxLength": 1024,
                    "title": "Reason For Close",
                    "type": "string"
                },
                "response_reason": {
                    "maxLength": 1024,
                    "title": "Response Reason",
                    "type": "string"
                },
                "state": {
                    "class_name": "CloseRequestState",
                    "enum": [
                        "pending",
                        "accepted",
                        "landlord_closed",
                        "rejected",
                        "cancelled"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "triggering_account_type": {
                    "class_name": "DepositAccountType",
                    "enum": [
                        "landlord",
                        "tenant",
                        "mediator"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "triggering_account_uid": {
                    "reference_type": "uuid",
                    "title": "Triggering Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                }
            },
            "required": [
                "amount_in_cents_to_landlord",
                "amount_in_cents_to_tenant",
                "attached_files_uid",
                "created_timestamp",
                "deposify_tags",
                "deposit_uid",
                "last_updated_timestamp",
                "notes",
                "reason_for_close",
                "response_reason",
                "state",
                "triggering_account_type",
                "triggering_account_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _DEPOSIT_GROUP_JSON_SCHEMA = {
    "$ref": "#/definitions/DepositGroupSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "DepositGroupSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount In Cents",
                    "type": "number"
                },
                "archived_for_account_uids": {
                    "items": {
                        "title": "archived_for_account_uids",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Archived For Account Uids",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "created_by_account_uid": {
                    "reference_type": "uuid",
                    "title": "Created By Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "deposit_states": {
                    "items": {
                        "class_name": "DepositState",
                        "enum": [
                            "pending",
                            "active",
                            "close_requested",
                            "closed",
                            "disputed",
                            "dispute_split_proposed",
                            "mediator_involved_dispute",
                            "mediator_split_proposed",
                            "cancelled"
                        ],
                        "reference_type": "enum",
                        "type": "string"
                    },
                    "title": "Deposit States",
                    "type": "array"
                },
                "deposit_uid_list": {
                    "items": {
                        "title": "deposit_uid_list",
                        "type": "string"
                    },
                    "maxItems": 300,
                    "reference_type": "uuid",
                    "title": "Deposit Uid List",
                    "type": "array",
                    "uid_resource_type": "deposit"
                },
                "description": {
                    "maxLength": 2048,
                    "title": "Description",
                    "type": "string"
                },
                "group_uid": {
                    "reference_type": "uuid",
                    "title": "Group Uid",
                    "type": "string",
                    "uid_resource_type": "deposit_group"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "owner_account_uid": {
                    "reference_type": "uuid",
                    "title": "Owner Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "title": {
                    "maxLength": 128,
                    "minLength": 3,
                    "title": "Title",
                    "type": "string"
                }
            },
            "required": [
                "amount_in_cents",
                "archived_for_account_uids",
                "created_by_account_uid",
                "created_timestamp",
                "deposify_tags",
                "deposit_states",
                "deposit_uid_list",
                "description",
                "group_uid",
                "last_updated_timestamp",
                "notes_uid",
                "owner_account_uid",
                "title"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _DEPOSIT_INTEREST_JSON_SCHEMA = {
    "$ref": "#/definitions/DepositInterestSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "DepositInterestSchema": {
            "additionalProperties": false,
            "properties": {
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount In Cents",
                    "type": "number"
                },
                "bank_account_interest_uid": {
                    "reference_type": "uuid",
                    "title": "Bank Account Interest Uid",
                    "type": "string",
                    "uid_resource_type": "bank_account_interest"
                },
                "bank_account_uid": {
                    "reference_type": "uuid",
                    "title": "Bank Account Uid",
                    "type": "string",
                    "uid_resource_type": "bank_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposit_uid": {
                    "reference_type": "uuid",
                    "title": "Deposit Uid",
                    "type": "string",
                    "uid_resource_type": "deposit"
                },
                "interest_end_date": {
                    "format": "date-time",
                    "title": "Interest End Date",
                    "type": "string"
                },
                "interest_start_date": {
                    "format": "date-time",
                    "title": "Interest Start Date",
                    "type": "string"
                },
                "interest_uid": {
                    "reference_type": "uuid",
                    "title": "Interest Uid",
                    "type": "string",
                    "uid_resource_type": "deposit_interest"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                }
            },
            "required": [
                "amount_in_cents",
                "bank_account_interest_uid",
                "bank_account_uid",
                "created_timestamp",
                "deposit_uid",
                "interest_end_date",
                "interest_start_date",
                "interest_uid",
                "last_updated_timestamp"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _DEPOSIT_INTEREST_LOG_JSON_SCHEMA = {
    "$ref": "#/definitions/DepositInterestLogSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "DepositInterestLogSchema": {
            "additionalProperties": false,
            "properties": {
                "bank_account_interest_rate_per_annum": {
                    "format": "decimal",
                    "maximum": 999999999999999.99999999999999999,
                    "minimum": 0.0,
                    "title": "Bank Account Interest Rate Per Annum",
                    "type": "number"
                },
                "bank_account_uid": {
                    "reference_type": "uuid",
                    "title": "Bank Account Uid",
                    "type": "string",
                    "uid_resource_type": "bank_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "day_count": {
                    "format": "integer",
                    "title": "Day Count",
                    "type": "number"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "deposit_uid": {
                    "reference_type": "uuid",
                    "title": "Deposit Uid",
                    "type": "string",
                    "uid_resource_type": "deposit"
                },
                "end_date": {
                    "format": "date-time",
                    "title": "End Date",
                    "type": "string"
                },
                "entry_uid": {
                    "reference_type": "uuid",
                    "title": "Entry Uid",
                    "type": "string",
                    "uid_resource_type": "deposit_interest_log"
                },
                "interest_in_cents_decimal": {
                    "format": "decimal",
                    "maximum": 999999999999999.99999999999999999,
                    "minimum": 0.0,
                    "title": "Interest In Cents Decimal",
                    "type": "number"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "principal_in_cents_decimal": {
                    "format": "decimal",
                    "maximum": 999999999999999.99999999999999999,
                    "minimum": 0.0,
                    "title": "Principal In Cents Decimal",
                    "type": "number"
                },
                "start_date": {
                    "format": "date-time",
                    "title": "Start Date",
                    "type": "string"
                }
            },
            "required": [
                "bank_account_interest_rate_per_annum",
                "bank_account_uid",
                "created_timestamp",
                "day_count",
                "deposify_tags",
                "deposit_uid",
                "end_date",
                "entry_uid",
                "interest_in_cents_decimal",
                "last_updated_timestamp",
                "principal_in_cents_decimal",
                "start_date"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _DEPOSIT_INVITE_JSON_SCHEMA = {
    "$ref": "#/definitions/DepositInviteSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "DepositInviteSchema": {
            "additionalProperties": false,
            "properties": {
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "deposit_uid": {
                    "reference_type": "uuid",
                    "title": "Deposit Uid",
                    "type": "string",
                    "uid_resource_type": "deposit"
                },
                "email_address": {
                    "title": "Email Address",
                    "type": "string"
                },
                "email_hash": {
                    "maxLength": 128,
                    "title": "Email Hash",
                    "type": "string"
                },
                "first_email_timestamp": {
                    "format": "date-time",
                    "title": "First Email Timestamp",
                    "type": "string"
                },
                "first_text_timestamp": {
                    "format": "date-time",
                    "title": "First Text Timestamp",
                    "type": "string"
                },
                "invitee_account_type": {
                    "class_name": "DepositAccountType",
                    "enum": [
                        "landlord",
                        "tenant",
                        "mediator"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "invitee_account_uid": {
                    "reference_type": "uuid",
                    "title": "Invitee Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "inviting_account_uid": {
                    "reference_type": "uuid",
                    "title": "Inviting Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "last_email_timestamp": {
                    "format": "date-time",
                    "title": "Last Email Timestamp",
                    "type": "string"
                },
                "last_text_timestamp": {
                    "format": "date-time",
                    "title": "Last Text Timestamp",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "phone_number": {
                    "title": "Phone Number",
                    "type": "string"
                },
                "sent_email_count": {
                    "format": "integer",
                    "title": "Sent Email Count",
                    "type": "number"
                },
                "sent_text_count": {
                    "format": "integer",
                    "title": "Sent Text Count",
                    "type": "number"
                },
                "state": {
                    "class_name": "DepositInviteState",
                    "enum": [
                        "no_invite_sent",
                        "sent",
                        "accepted",
                        "rejected"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "use_email_address": {
                    "title": "Use Email Address",
                    "type": "boolean"
                },
                "use_phone_number": {
                    "title": "Use Phone Number",
                    "type": "boolean"
                }
            },
            "required": [
                "created_timestamp",
                "deposify_tags",
                "deposit_uid",
                "email_address",
                "email_hash",
                "first_email_timestamp",
                "first_text_timestamp",
                "invitee_account_type",
                "invitee_account_uid",
                "inviting_account_uid",
                "last_email_timestamp",
                "last_text_timestamp",
                "last_updated_timestamp",
                "phone_number",
                "sent_email_count",
                "sent_text_count",
                "state",
                "use_email_address",
                "use_phone_number"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _DEPOSIT_POST_CLOSE_ADJUSTMENT_JSON_SCHEMA = {
    "$ref": "#/definitions/DepositPostCloseAdjustmentSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "DepositPostCloseAdjustmentSchema": {
            "additionalProperties": false,
            "properties": {
                "actual_amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Actual Amount In Cents",
                    "type": "number"
                },
                "adjustment_uid": {
                    "reference_type": "uuid",
                    "title": "Adjustment Uid",
                    "type": "string",
                    "uid_resource_type": "deposit_post_close_adjustment"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "deposit_uid": {
                    "reference_type": "uuid",
                    "title": "Deposit Uid",
                    "type": "string",
                    "uid_resource_type": "deposit"
                },
                "goal_amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount",
                    "type": "number",
                    "ui:placeholder": "$0",
                    "ui:widget": "DollarInputField"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "private_notes": {
                    "title": "Private Notes",
                    "type": "string"
                },
                "public_reason_for_adjustment": {
                    "title": "Public Reason For Adjustment",
                    "type": "string"
                },
                "recipient_account_uid": {
                    "reference_type": "uuid",
                    "title": "Recipient Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "state": {
                    "class_name": "DepositPostCloseAdjustmentState",
                    "enum": [
                        "waiting_for_close",
                        "used",
                        "unusable"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "target_account_type": {
                    "class_name": "DepositAccountType",
                    "enum": [
                        "landlord",
                        "tenant",
                        "mediator"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "target_account_uid": {
                    "reference_type": "uuid",
                    "title": "Target Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "use_recipient_account": {
                    "title": "Use Recipient Account",
                    "type": "boolean"
                }
            },
            "required": [
                "actual_amount_in_cents",
                "adjustment_uid",
                "deposit_uid",
                "goal_amount_in_cents",
                "private_notes",
                "public_reason_for_adjustment",
                "recipient_account_uid",
                "state",
                "target_account_type",
                "target_account_uid",
                "use_recipient_account"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _DEPOSIT_USER_GROUP_JSON_SCHEMA = {
    "$ref": "#/definitions/DepositUserGroupSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "DepositUserGroupSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposit_uid": {
                    "reference_type": "uuid",
                    "title": "Deposit Uid",
                    "type": "string",
                    "uid_resource_type": "deposit"
                },
                "group_uids": {
                    "items": {
                        "title": "group_uids",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Group Uids",
                    "type": "array"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                }
            },
            "required": [
                "account_uid",
                "created_timestamp",
                "deposit_uid",
                "group_uids",
                "last_updated_timestamp"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _DEPOSIT_USER_STATS_JSON_SCHEMA = {
    "$ref": "#/definitions/DepositUserStatsSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "DepositUserStatsSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "stats": {
                    "additionalProperties": {},
                    "title": "Stats",
                    "type": "object"
                }
            },
            "required": [
                "account_uid",
                "last_updated_timestamp",
                "stats"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _DEPOSIT_WITHHELD_FUNDS_JSON_SCHEMA = {
    "$ref": "#/definitions/DepositWithheldFundsSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "DepositWithheldFundsSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "amount_in_cents": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount In Cents",
                    "type": "number"
                },
                "attached_files_uid": {
                    "reference_type": "uuid",
                    "title": "Attached Files Uid",
                    "type": "string",
                    "uid_resource_type": "attached_storage_files"
                },
                "cancelled_timestamp": {
                    "format": "date-time",
                    "title": "Cancelled Timestamp",
                    "type": "string"
                },
                "created_by_account_uid": {
                    "reference_type": "uuid",
                    "title": "Created By Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "deposit_uid": {
                    "reference_type": "uuid",
                    "title": "Deposit Uid",
                    "type": "string",
                    "uid_resource_type": "deposit"
                },
                "description": {
                    "maxLength": 2048,
                    "title": "Description",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "state": {
                    "class_name": "DepositWithheldFundsState",
                    "enum": [
                        "active",
                        "cancelled"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "title": {
                    "maxLength": 512,
                    "title": "Title",
                    "type": "string"
                },
                "withheld_uid": {
                    "reference_type": "uuid",
                    "title": "Withheld Uid",
                    "type": "string",
                    "uid_resource_type": "deposit_withheld_funds"
                }
            },
            "required": [
                "amount_in_cents",
                "created_by_account_uid",
                "deposit_uid",
                "description",
                "title"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _DISPUTE_JSON_SCHEMA = {
    "$ref": "#/definitions/DisputeSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "DisputeSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "active_dispute_split_uid": {
                    "reference_type": "uuid",
                    "title": "Active Dispute Split Uid",
                    "type": "string",
                    "uid_resource_type": "dispute_split"
                },
                "attached_files_uid": {
                    "reference_type": "uuid",
                    "title": "Attached Files Uid",
                    "type": "string",
                    "uid_resource_type": "attached_storage_files"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposit_uid": {
                    "reference_type": "uuid",
                    "title": "Deposit Uid",
                    "type": "string",
                    "uid_resource_type": "deposit"
                },
                "dispute_uid": {
                    "reference_type": "uuid",
                    "title": "Dispute Uid",
                    "type": "string",
                    "uid_resource_type": "dispute"
                },
                "first_dispute_split_uid": {
                    "reference_type": "uuid",
                    "title": "First Dispute Split Uid",
                    "type": "string",
                    "uid_resource_type": "dispute_split"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes": {
                    "title": "Notes",
                    "type": "string"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "reason_for_dispute": {
                    "title": "Reason For Dispute",
                    "type": "string"
                },
                "state": {
                    "class_name": "DisputeState",
                    "enum": [
                        "active",
                        "active_with_mediator",
                        "cancelled",
                        "ended"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "triggering_account_type": {
                    "class_name": "DepositAccountType",
                    "enum": [
                        "landlord",
                        "tenant",
                        "mediator"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "triggering_account_uid": {
                    "reference_type": "uuid",
                    "title": "Triggering Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                }
            },
            "required": [
                "active_dispute_split_uid",
                "attached_files_uid",
                "created_timestamp",
                "deposit_uid",
                "dispute_uid",
                "first_dispute_split_uid",
                "last_updated_timestamp",
                "notes",
                "reason_for_dispute",
                "state",
                "triggering_account_type",
                "triggering_account_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _DISPUTE_INTERVENTION_REQUEST_JSON_SCHEMA = {
    "$ref": "#/definitions/DisputeInterventionRequestSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "DisputeInterventionRequestSchema": {
            "additionalProperties": false,
            "properties": {
                "attached_files_uid": {
                    "reference_type": "uuid",
                    "title": "Attached Files Uid",
                    "type": "string",
                    "uid_resource_type": "attached_storage_files"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "dispute_uid": {
                    "reference_type": "uuid",
                    "title": "Dispute Uid",
                    "type": "string",
                    "uid_resource_type": "dispute"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes": {
                    "title": "Notes",
                    "type": "string"
                },
                "reason_for_request": {
                    "title": "Reason For Request",
                    "type": "string"
                },
                "request_uid": {
                    "reference_type": "uuid",
                    "title": "Request Uid",
                    "type": "string",
                    "uid_resource_type": "dispute_intervention_request"
                },
                "state": {
                    "class_name": "DisputeInterventionRequestState",
                    "enum": [
                        "requested",
                        "in_progress",
                        "closed"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "triggering_account_type": {
                    "class_name": "DepositAccountType",
                    "enum": [
                        "landlord",
                        "tenant",
                        "mediator"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "triggering_account_uid": {
                    "reference_type": "uuid",
                    "title": "Triggering Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                }
            },
            "required": [
                "attached_files_uid",
                "created_timestamp",
                "dispute_uid",
                "last_updated_timestamp",
                "notes",
                "reason_for_request",
                "request_uid",
                "state",
                "triggering_account_type",
                "triggering_account_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _DISPUTE_SPLIT_JSON_SCHEMA = {
    "$ref": "#/definitions/DisputeSplitSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "DisputeSplitSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "amount_in_cents_to_landlord": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount In Cents To Landlord",
                    "type": "number"
                },
                "amount_in_cents_to_tenant": {
                    "cents_value": true,
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": 0,
                    "title": "Amount In Cents To Tenant",
                    "type": "number"
                },
                "attached_files_uid": {
                    "reference_type": "uuid",
                    "title": "Attached Files Uid",
                    "type": "string",
                    "uid_resource_type": "attached_storage_files"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposit_uid": {
                    "reference_type": "uuid",
                    "title": "Deposit Uid",
                    "type": "string",
                    "uid_resource_type": "deposit"
                },
                "dispute_uid": {
                    "reference_type": "uuid",
                    "title": "Dispute Uid",
                    "type": "string",
                    "uid_resource_type": "dispute"
                },
                "landlord_account_uid": {
                    "reference_type": "uuid",
                    "title": "Landlord Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "landlord_response": {
                    "class_name": "DisputeSplitResponse",
                    "enum": [
                        "awaiting_response",
                        "rejected",
                        "accepted"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "landlord_response_timestamp": {
                    "format": "date-time",
                    "title": "Landlord Response Timestamp",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "proposing_account_type": {
                    "class_name": "DepositAccountType",
                    "enum": [
                        "landlord",
                        "tenant",
                        "mediator"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "proposing_account_uid": {
                    "reference_type": "uuid",
                    "title": "Proposing Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "response_message": {
                    "title": "Response Message",
                    "type": "string"
                },
                "split_message": {
                    "title": "Split Message",
                    "type": "string"
                },
                "split_uid": {
                    "reference_type": "uuid",
                    "title": "Split Uid",
                    "type": "string",
                    "uid_resource_type": "dispute_split"
                },
                "state": {
                    "class_name": "DisputeSplitState",
                    "enum": [
                        "awaiting_response",
                        "rejected",
                        "accepted",
                        "cancelled"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "tenant_account_uid": {
                    "reference_type": "uuid",
                    "title": "Tenant Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "tenant_response": {
                    "class_name": "DisputeSplitResponse",
                    "enum": [
                        "awaiting_response",
                        "rejected",
                        "accepted"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "tenant_response_timestamp": {
                    "format": "date-time",
                    "title": "Tenant Response Timestamp",
                    "type": "string"
                }
            },
            "required": [
                "amount_in_cents_to_landlord",
                "amount_in_cents_to_tenant",
                "attached_files_uid",
                "created_timestamp",
                "deposit_uid",
                "dispute_uid",
                "landlord_account_uid",
                "landlord_response",
                "landlord_response_timestamp",
                "last_updated_timestamp",
                "proposing_account_type",
                "proposing_account_uid",
                "response_message",
                "split_message",
                "split_uid",
                "state",
                "tenant_account_uid",
                "tenant_response",
                "tenant_response_timestamp"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _PMC_REPORT_TIMETABLE_JSON_SCHEMA = {
    "$ref": "#/definitions/PMCReportTimetableSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "PMCReportTimetableSchema": {
            "additionalProperties": false,
            "properties": {
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "landlord_account_uid_list": {
                    "items": {
                        "title": "landlord_account_uid_list",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Landlord Account Uid List",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "notes_uid": {
                    "reference_type": "uuid",
                    "title": "Notes Uid",
                    "type": "string",
                    "uid_resource_type": "resource_note"
                },
                "recipient_account_uid": {
                    "reference_type": "uuid",
                    "title": "Recipient Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "timetable_uid": {
                    "reference_type": "uuid",
                    "title": "Timetable Uid",
                    "type": "string",
                    "uid_resource_type": "pmc_report_timetable"
                }
            },
            "required": [
                "created_timestamp",
                "deposify_tags",
                "landlord_account_uid_list",
                "last_updated_timestamp",
                "notes_uid",
                "recipient_account_uid",
                "timetable_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _PROPERTY_JSON_SCHEMA = {
    "$ref": "#/definitions/PropertySchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "PropertySchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "creating_account_uid": {
                    "reference_type": "uuid",
                    "title": "Creating Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "meta_data_string_tags": {
                    "items": {
                        "title": "meta_data_string_tags",
                        "type": "string"
                    },
                    "title": "Meta Data String Tags",
                    "type": "array"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "parent_property_uid": {
                    "reference_type": "uuid",
                    "title": "Parent Property Uid",
                    "type": "string",
                    "uid_resource_type": "property"
                },
                "property_address_uid": {
                    "reference_type": "uuid",
                    "title": "Property Address Uid",
                    "type": "string",
                    "uid_resource_type": "property_address"
                },
                "property_manager_uids": {
                    "items": {
                        "reference_type": "uuid",
                        "title": "property_manager_uids",
                        "type": "string",
                        "uid_resource_type": "user_account"
                    },
                    "title": "Property Manager Uids",
                    "type": "array"
                },
                "property_stats_processing_id": {
                    "format": "integer",
                    "title": "Property Stats Processing Id",
                    "type": "number"
                },
                "property_type": {
                    "class_name": "PropertyType",
                    "enum": [
                        "apartment",
                        "unit",
                        "apartment_building",
                        "apartment_building_floor",
                        "house",
                        "building",
                        "building_floor",
                        "room",
                        "townhouse",
                        "city",
                        "district",
                        "community",
                        "gated_community",
                        "housing_estate",
                        "dormitory",
                        "dormitory_unit",
                        "duplex",
                        "duplex_unit",
                        "suite",
                        "cabin",
                        "chalet",
                        "cottage",
                        "retirement_community",
                        "villa",
                        "assisted_living",
                        "village",
                        "property"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "property_uid": {
                    "reference_type": "uuid",
                    "title": "Property Uid",
                    "type": "string",
                    "uid_resource_type": "property"
                },
                "title": {
                    "title": "Title",
                    "type": "string"
                },
                "unit_apt_number": {
                    "title": "Unit Apt Number",
                    "type": "string"
                },
                "user_can_delete": {
                    "title": "User Can Delete",
                    "type": "boolean"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                },
                "voyager_property_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Property Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property"
                },
                "voyager_property_unit_uid": {
                    "reference_type": "uuid",
                    "title": "Voyager Property Unit Uid",
                    "type": "string",
                    "uid_resource_type": "yardi_voyager_property_unit"
                },
                "partner_bank_account_uid": {
                    "reference_type": "uuid",
                    "title": "Partner Bank Account",
                    "type": "string",
                    "uid_resource_type": "bank_account"
                },
                "partner_bank_account_disabled": {
                    "title": "Partner Bank Account Disabled",
                    "type": "boolean"
                }
            },
            "required": [
                "created_timestamp",
                "creating_account_uid",
                "deposify_tags",
                "last_updated_timestamp",
                "meta_data_string_tags",
                "parent_property_uid",
                "property_address_uid",
                "property_manager_uids",
                "property_stats_processing_id",
                "property_type",
                "property_uid",
                "title",
                "unit_apt_number",
                "user_can_delete",
                "version",
                "voyager_property_uid",
                "voyager_property_unit_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _PROPERTY_ADDRESS_JSON_SCHEMA = {
    "$ref": "#/definitions/PropertyAddressSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "PropertyAddressSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "city": {
                    "title": "City",
                    "type": "string"
                },
                "country": {
                    "title": "Country",
                    "type": "string"
                },
                "county": {
                    "title": "County",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "creating_account_uid": {
                    "reference_type": "uuid",
                    "title": "Creating Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "district": {
                    "title": "District",
                    "type": "string"
                },
                "house_number": {
                    "title": "House Number",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "latitude": {
                    "format": "float",
                    "title": "Latitude",
                    "type": "number"
                },
                "location_id": {
                    "title": "Location Id",
                    "type": "string"
                },
                "location_id_type": {
                    "class_name": "LocationIDType",
                    "enum": [
                        "manual",
                        "here"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "location_match_level": {
                    "class_name": "HereLocationMatchLevel",
                    "enum": [
                        "manual",
                        "country",
                        "state",
                        "county",
                        "city",
                        "district",
                        "street",
                        "intersection",
                        "houseNumber",
                        "postalCode",
                        "landmark"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "longitude": {
                    "format": "float",
                    "title": "Longitude",
                    "type": "number"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "postal_code": {
                    "title": "Postal Code",
                    "type": "string"
                },
                "property_address_uid": {
                    "reference_type": "uuid",
                    "title": "Property Address Uid",
                    "type": "string",
                    "uid_resource_type": "property_address"
                },
                "state": {
                    "title": "State",
                    "type": "string"
                },
                "street": {
                    "title": "Street",
                    "type": "string"
                },
                "user_can_delete": {
                    "title": "User Can Delete",
                    "type": "boolean"
                },
                "version": {
                    "maxLength": 10,
                    "minLength": 1,
                    "title": "Version",
                    "type": "string"
                }
            },
            "required": [
                "city",
                "country",
                "county",
                "created_timestamp",
                "creating_account_uid",
                "deposify_tags",
                "district",
                "house_number",
                "last_updated_timestamp",
                "latitude",
                "location_id",
                "location_id_type",
                "location_match_level",
                "longitude",
                "postal_code",
                "property_address_uid",
                "state",
                "street",
                "user_can_delete",
                "version"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _PROPERTY_GROUP_JSON_SCHEMA = {
    "$ref": "#/definitions/PropertyGroupSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "PropertyGroupSchema": {
            "additionalProperties": false,
            "properties": {
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "creating_account_uid": {
                    "reference_type": "uuid",
                    "title": "Creating Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "group_uid": {
                    "reference_type": "uuid",
                    "title": "Group Uid",
                    "type": "string",
                    "uid_resource_type": "property_group"
                },
                "html_colour_code": {
                    "title": "Html Colour Code",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "parent_group_uid": {
                    "reference_type": "uuid",
                    "title": "Parent Group Uid",
                    "type": "string",
                    "uid_resource_type": "property_group"
                },
                "subtitle": {
                    "title": "Subtitle",
                    "type": "string"
                },
                "title": {
                    "title": "Title",
                    "type": "string"
                }
            },
            "required": [
                "created_timestamp",
                "creating_account_uid",
                "group_uid",
                "html_colour_code",
                "last_updated_timestamp",
                "parent_group_uid",
                "subtitle",
                "title"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _PROPERTY_USER_GROUP_JSON_SCHEMA = {
    "$ref": "#/definitions/PropertyUserGroupSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "PropertyUserGroupSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "group_uids": {
                    "items": {
                        "title": "group_uids",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Group Uids",
                    "type": "array"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "property_uid": {
                    "reference_type": "uuid",
                    "title": "Property Uid",
                    "type": "string",
                    "uid_resource_type": "property_user_group"
                }
            },
            "required": [
                "account_uid",
                "created_timestamp",
                "group_uids",
                "last_updated_timestamp",
                "property_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};


export const ARCHIVED_DEPOSIT_CLOSE_REQUEST_JSON_SCHEMA = _ARCHIVED_DEPOSIT_CLOSE_REQUEST_JSON_SCHEMA.definitions.ArchivedDepositCloseRequestSchema;
export const COMPLIANCE_JSON_SCHEMA = _COMPLIANCE_JSON_SCHEMA.definitions.ComplianceSchema;
export const COMPLIANCE_HISTORY_JSON_SCHEMA = _COMPLIANCE_HISTORY_JSON_SCHEMA.definitions.ComplianceHistorySchema;
export const COMPLIANCE_RULE_JSON_SCHEMA = _COMPLIANCE_RULE_JSON_SCHEMA.definitions.ComplianceRuleSchema;
export const DEPOSIT_JSON_SCHEMA = _DEPOSIT_JSON_SCHEMA.definitions.DepositSchema;
export const DEPOSIT_ADJUSTMENT_JSON_SCHEMA = _DEPOSIT_ADJUSTMENT_JSON_SCHEMA.definitions.DepositAdjustmentSchema;
export const DEPOSIT_BANK_MAPPING_JSON_SCHEMA = _DEPOSIT_BANK_MAPPING_JSON_SCHEMA.definitions.DepositBankMappingSchema;
export const DEPOSIT_BULK_IMPORT_JSON_SCHEMA = _DEPOSIT_BULK_IMPORT_JSON_SCHEMA.definitions.DepositBulkImportSchema;
export const DEPOSIT_CLOSE_REQUEST_JSON_SCHEMA = _DEPOSIT_CLOSE_REQUEST_JSON_SCHEMA.definitions.DepositCloseRequestSchema;
export const DEPOSIT_GROUP_JSON_SCHEMA = _DEPOSIT_GROUP_JSON_SCHEMA.definitions.DepositGroupSchema;
export const DEPOSIT_INTEREST_JSON_SCHEMA = _DEPOSIT_INTEREST_JSON_SCHEMA.definitions.DepositInterestSchema;
export const DEPOSIT_INTEREST_LOG_JSON_SCHEMA = _DEPOSIT_INTEREST_LOG_JSON_SCHEMA.definitions.DepositInterestLogSchema;
export const DEPOSIT_INVITE_JSON_SCHEMA = _DEPOSIT_INVITE_JSON_SCHEMA.definitions.DepositInviteSchema;
export const DEPOSIT_POST_CLOSE_ADJUSTMENT_JSON_SCHEMA = _DEPOSIT_POST_CLOSE_ADJUSTMENT_JSON_SCHEMA.definitions.DepositPostCloseAdjustmentSchema;
export const DEPOSIT_USER_GROUP_JSON_SCHEMA = _DEPOSIT_USER_GROUP_JSON_SCHEMA.definitions.DepositUserGroupSchema;
export const DEPOSIT_USER_STATS_JSON_SCHEMA = _DEPOSIT_USER_STATS_JSON_SCHEMA.definitions.DepositUserStatsSchema;
export const DEPOSIT_WITHHELD_FUNDS_JSON_SCHEMA = _DEPOSIT_WITHHELD_FUNDS_JSON_SCHEMA.definitions.DepositWithheldFundsSchema;
export const DISPUTE_JSON_SCHEMA = _DISPUTE_JSON_SCHEMA.definitions.DisputeSchema;
export const DISPUTE_INTERVENTION_REQUEST_JSON_SCHEMA = _DISPUTE_INTERVENTION_REQUEST_JSON_SCHEMA.definitions.DisputeInterventionRequestSchema;
export const DISPUTE_SPLIT_JSON_SCHEMA = _DISPUTE_SPLIT_JSON_SCHEMA.definitions.DisputeSplitSchema;
export const PMC_REPORT_TIMETABLE_JSON_SCHEMA = _PMC_REPORT_TIMETABLE_JSON_SCHEMA.definitions.PMCReportTimetableSchema;
export const PROPERTY_JSON_SCHEMA = _PROPERTY_JSON_SCHEMA.definitions.PropertySchema;
export const PROPERTY_ADDRESS_JSON_SCHEMA = _PROPERTY_ADDRESS_JSON_SCHEMA.definitions.PropertyAddressSchema;
export const PROPERTY_GROUP_JSON_SCHEMA = _PROPERTY_GROUP_JSON_SCHEMA.definitions.PropertyGroupSchema;
export const PROPERTY_USER_GROUP_JSON_SCHEMA = _PROPERTY_USER_GROUP_JSON_SCHEMA.definitions.PropertyUserGroupSchema;
